import React from 'react'
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import ContactUsSection from './ContactUsSection';
import {
  Wrapper,
  BackgroundImage,
  ContentOverlay,
  Heading,
  Paragraph,
  ContactButton,
  ModalHeaderTitle,
} from '../styles/ContactUsStyles';

const ContactUs = () => {
  const [showContactModal, setShowContactModal]=useState(false);

  const handleShowContactModal = () => setShowContactModal(true);
  const handleCloseContactModal = () => setShowContactModal(false);

  return (
    <Wrapper>
      {/* Background Image */}
      <BackgroundImage
        src="/assets/images/background1.jpg"
        alt="background"
      />

      {/* Content Overlay */}
      <ContentOverlay>
        <Heading>Work With Us</Heading>
        <Paragraph>
          With exceptional networking and research skills, The Sophia Matthew Group excels at finding hidden, ‘off-market listings and matching her buyers with the perfect homes and lifestyles to fit their needs.
        </Paragraph>
        <ContactButton href="#home" onClick={handleShowContactModal}>
          Contact Us
        </ContactButton>
      </ContentOverlay>

      {/* Modal */}
      <Modal show={showContactModal} onHide={handleCloseContactModal} fullscreen>
        <Modal.Header closeButton>
          <ModalHeaderTitle>Contact Us</ModalHeaderTitle>
        </Modal.Header>
        <Modal.Body>
          <ContactUsSection />
        </Modal.Body>
      </Modal>
    </Wrapper>
  )
}

export default ContactUs